import React, {Component} from 'react';
import {resetCartData, checkoutCart} from '../actions/nCartAppActions'
import {connect} from "react-redux";
import {bindActionCreators} from 'redux';
import NCart from '../components/NCart'
import NUser from "../components/NUser";
import NResult from "../components/NResult";
import {setResultData} from "../actions/nResultActions"
import {validateMinLength, validateEmail, validateNumbers} from "../utils/validators"


class NCartPage extends Component {

  constructor(props) {
    super(props);
    this.sendOrder = this.sendOrder.bind(this);

    /*
    if (props.attrs.num_items && props.attrs.num_items.value){
        props.resetCartData({num_items: props.attrs.num_items.value});
    }
     */
  }
  componentDidMount() {

      if (this.props.attrs.num_items && this.props.attrs.num_items.value){
        this.props.resetCartData({num_items: this.props.attrs.num_items.value});
      }
  }

  sendOrder(){

      //validation
      let valid = true;
      let message = "";
      let title = "";
      let all_enabled = true;

      // состояние корзины
      if ((this.props.ncart.status==="ERROR")||(this.props.nshipping.status==="ERROR")){
          title = "К сожалению при загрузке страницы возникли проблемы";
          message = "Обновите страницу (Нажмите F5) и повторите отправку";
          valid = false;

      }else if ((this.props.ncart.status!=="READY")||(this.props.nshipping.status === "FETCHING")){
          title = "Данные корзины обновляются";
          message = "Для отправки заказа необходимо дождаться обновления данных корзины. Повторите отправку через несколько секунд";
          valid = false
      }

      // enabled для элементов
      this.props.ncart.items.forEach(element => {

          if((element.checked)&&(!element.summary.enabled)&&(element.summary.enabled_help_text)){
            valid = false;
            title = "Не все элементы корзины в наличии в нужном количестве";
            message+="<strong>Артикул: "+element.summary.art+"</strong> " + element.summary.enabled_help_text +"<br/><br/>";
            message+="<strong class='error-text'>Измените количество данных товаров в заказе или снимите активность для заказа позднее!</strong>";
          }
      });


      if (!valid){
           this.props.setResultData({visible: true,
                status: "ERROR",
                title: title,
                message: message})
          return false
      }

      // данные пользователя
      if (validateMinLength(this.props.nuser.fio, 6)){
          message += "<strong>Поле ФИО:</strong> не заполнено либо слишком короткое значение;<br>";
          valid = false;
      }
      if (validateEmail(this.props.nuser.email)){

          message += "<strong>Поле Email:</strong> не заполнено не верно;<br>";
          valid = false;
      }

      if (validateMinLength(this.props.nuser.phone, 6)){

          message += "<strong>Поле Телефон:</strong> не заполнено либо слишком короткое значение;<br>";
          valid = false;
      }

      if(!this.props.nuser.confirm_rules){
          message += "<strong>Поле условия использования:</strong> Необходимо согласиться;<br>";
          valid = false;
      }

      title =  "Контактная информация указана не полностью";

      if (!valid){
           this.props.setResultData({visible: true,
                status: "ERROR",
                title: title,
                message: message})
          return false
      }

      if (this.props.npayment.method==="invoice"){

          if (validateMinLength(this.props.npayment.variants.invoice.data.name, 6)){
            message += "<strong>Поле Наименование организации:</strong> не заполнено либо слишком короткое значение;<br>";
            valid = false;
          }
          if (validateMinLength(this.props.npayment.variants.invoice.data.inn, 6)){
            message += "<strong>Поле ИНН организации:</strong> не заполнено либо слишком короткое значение;<br>";
            valid = false;
          }else if (validateNumbers(this.props.npayment.variants.invoice.data.inn)){
            message += "<strong>Поле ИНН организации:</strong> содержит не только числа;<br>";
            valid = false;
          }
          if (this.props.npayment.variants.invoice.data.kpp.length > 0){
              if (validateMinLength(this.props.npayment.variants.invoice.data.kpp, 6)){
                message += "<strong>Поле КПП организации:</strong> не заполнено либо слишком короткое значение;<br>";
                valid = false;
              }else if (validateNumbers(this.props.npayment.variants.invoice.data.kpp)){
                message += "<strong>Поле КПП организации:</strong> содержит не только числа;<br>";
                valid = false;
              }
          }

          if (validateMinLength(this.props.npayment.variants.invoice.data.ogrn, 6)){
            message += "<strong>Поле ОГРН организации:</strong> не заполнено либо слишком короткое значение;<br>";
            valid = false;
          }else if (validateNumbers(this.props.npayment.variants.invoice.data.ogrn)){
            message += "<strong>Поле ОГРН организации:</strong> содержит не только числа;<br>";
            valid = false;
          }
          if (validateMinLength(this.props.npayment.variants.invoice.data.address, 6)){
            message += "<strong>Поле Адрес организации:</strong> не заполнено либо слишком короткое значение;<br>";
            valid = false;
          }
          if (validateMinLength(this.props.npayment.variants.invoice.data.real_address, 6)){
            message += "<strong>Поле Фактический адрес организации:</strong> не заполнено либо слишком короткое значение;<br>";
            valid = false;
          }
          if (validateMinLength(this.props.npayment.variants.invoice.data.phone, 6)){
            message += "<strong>Поле телефон организации:</strong> не заполнено либо слишком короткое значение;<br>";
            valid = false;
          }
          if (validateMinLength(this.props.npayment.variants.invoice.data.bank, 6)){
            message += "<strong>Поле Банк:</strong> не заполнено либо слишком короткое значение;<br>";
            valid = false;
          }
          if (validateMinLength(this.props.npayment.variants.invoice.data.bik, 6)){
            message += "<strong>Поле БИК:</strong> не заполнено либо слишком короткое значение;<br>";
            valid = false;
          }else if (validateNumbers(this.props.npayment.variants.invoice.data.bik)){
            message += "<strong>Поле БИК:</strong> содержит не только числа;<br>";
            valid = false;
          }

          if (validateMinLength(this.props.npayment.variants.invoice.data.bank_schet, 19)){
            message += "<strong>Поле Кор. счет:</strong> не заполнено либо слишком короткое значение;<br>";
            valid = false;
          }else if (validateNumbers(this.props.npayment.variants.invoice.data.bank_schet)){
            message += "<strong>Поле Кор. счет:</strong> содержит не только числа;<br>";
            valid = false;
          }
          if (validateMinLength(this.props.npayment.variants.invoice.data.org_schet, 19)){
            message += "<strong>Поле Расчетный счет:</strong> не заполнено либо слишком короткое значение;<br>";
            valid = false;
          }else if (validateNumbers(this.props.npayment.variants.invoice.data.org_schet)){
            message += "<strong>Поле Расчетный счет:</strong> содержит не только числа;<br>";
            valid = false;
          }

      }

      title =  "Реквизиты организации заполнены не полностью";
      if (!valid){
           this.props.setResultData({visible: true,
                status: "ERROR",
                title: title,
                message: message})
          return false
      }

      if (valid){
          this.props.checkoutCart({
              shipping: this.props.nshipping,
              payment: this.props.npayment,
              user: this.props.nuser,
              total: this.props.ncart.total,
              num_items: this.props.ncart.num_items,
          })
      }

  }

  render() {
    return (
        <div className="ncartdetail-container">
          <div className="ncard cart-detail">
            <NCart/>
          </div>
            <NUser sendOrder={this.sendOrder}/>
            <div>
                <NResult/>
            </div>
        </div>
    );
  }
}

const mapStateToProps = state => (state);

const mapDispatchToProps = dispatch => bindActionCreators({resetCartData, setResultData, checkoutCart}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(NCartPage);